import React, {useEffect, useState} from 'react';
import {useAppDispatch, useAppSelector} from '../../redux/hooks';
import cogoToast from 'cogo-toast';
import comingSoonElite from '../../assets/images/comingSoonElite.svg';
import MaxElite from '../../assets/images/Max_Elite.jpg';
import aftermembership from '../../assets/images/aftermembership.jpg';

import beforemembership from '../../assets/images/beforemembership.jpg';

import {
  getAccessToken,
  getStoreCode,
  getStoreInformation,
  getUser,
} from '../../core/localstorage-data';
import {
  EliteNumericStoreCode,
  EliteEnableStatus,
  EliteAlphaNumStoreCode,
} from '../../lib/constants';
import {
  eliteMembershipSubscription,
  eliteResponse,
  notification,
  resetNotification,
} from '../../redux/orderSlice';
import {useHistory} from 'react-router';
import SuccessToast from '../../components/notifications/SuccessToast';
let counts = 0;
export const EliteEnrollment = () => {
  const dispatch = useAppDispatch();
  const navigate = useHistory();
  const customerProfileData = getUser();
  const storeInformation = getStoreInformation();
  const storeCode = `0${storeInformation.store_code}`;
  const numericStoreCode = storeInformation.store_code;
  const storeKeyId = getStoreCode();
  const accessToken = getAccessToken();
  const eliteResp = useAppSelector(eliteResponse);
  const notificationState = useAppSelector(notification);
  console.log(customerProfileData);
  const [buttonText, setButtonText] = useState('');
  const [Text, setText] = useState('');
  const [button, setButton] = useState(false);
  const [showElite, setShowElite] = useState(false);
  const [image, setImage] = useState(beforemembership);

  useEffect(() => {
    EliteNumericStoreCode.map(storecode => {
      if (storecode === numericStoreCode && EliteEnableStatus === true) {
        setShowElite(true);
        setButton(false);
        counts++;
      }
    });
    EliteAlphaNumStoreCode.map(storecode => {
      if (storecode === storeKeyId && EliteEnableStatus === true) {
        setShowElite(true);
        setButton(false);
        counts++;
      }
    });
    if (
      customerProfileData.tier == 'NON-ELITE' ||
      customerProfileData.tier == 'NON-EDGE'
    ) {
      setImage(beforemembership);
      if (customerProfileData.validity == null) {
        setText('Become an Elite member today to enjoy the benefits');
        setButtonText('Enrol @ Rs499 ONLY');
      } else {
        setText('Renew Elite Membership to continue enjoying the benefits');
        setButtonText('Renew ELITE');
      }
    } else if (
      customerProfileData.validity != null &&
      (customerProfileData.tier == 'ELITE' ||
        customerProfileData.tier == 'EDGE')
    ) {
      setImage(aftermembership);
      const date1 = new Date();
      const date2 = new Date(customerProfileData.validity);
      const oneDay = 1000 * 60 * 60 * 24;
      // Calculating the time difference between two dates
      const diffInTime = date2.getTime() - date1.getTime();

      // Calculating the no. of days between two dates
      const diffInDays = Math.ceil(diffInTime / oneDay);
      if (diffInDays < 30) {
        setButtonText('Renew ELITE');
        setText('Renew Elite Membership to continue enjoying the benefits ');
      } else {
        setText('Enjoy the Benefits ');
        setButton(true);
        setButtonText('Enroll ELITE');

        //valid membership. disable any renewal or enrolment
      }
    }
  }, []);

  useEffect(() => {
    if (notificationState?.statusCode === '200') {
      navigate.push('/checkout/shoppingbag');
      dispatch(resetNotification());
    }
    if (notificationState?.statusCode === '1041') {
      cogoToast.success(
        <SuccessToast
          title="Membership added"
          description={
            notificationState.statusMessage ||
            'Membership is already added to the shopping bag'
          }
        />,
        {
          hideAfter: 5,
          renderIcon: () => {
            return null;
          },
        },
      );
      dispatch(resetNotification());
    }
  }, [notificationState]);

  // for elite functionality
  function handleClick() {
    if (storeCode && storeKeyId) {
      const parameters = {
        accessToken,
        payload: {
          storeCode,
          storeKeyId,
        },
      };
      dispatch(eliteMembershipSubscription(parameters));
    }
  }

  return (
    <div className="grid place-items-center">
      <div className="mx-auto pl-8 pr-8">
        {counts != 0 ? (
          <div>
            {showElite ? (
              <img
                src={image}
                className="w-96 h-auto mt-6 rounded-xl"
                alt="Comming_Soon"
              />
            ) : (
              <img
                src={comingSoonElite}
                className="w-auto h-auto mt-6 rounded-xl"
                alt="Comming_Soon"
              />
            )}
          </div>
        ) : (
          <img
                src={comingSoonElite}
                className="w-auto h-auto mt-6 rounded-xl"
                alt="Comming_Soon"
              />
        )}

        {buttonText !== '' && (
          <div className="grid place-items-center">
            <div className="w-full h-12 text-sm text-black text-center mt-4 leading-4">
              {showElite ? Text : ''}
            </div>
            {showElite ? (
              <button
                disabled={button}
                className={`cursor-none-allowed text-white h-50 rounded-radius10  grid place-items-center focus:outline-none w-full text-center primary normal`}
                onClick={handleClick}>
                {buttonText}
              </button>
            ) : (
              <>
              {/* <button
                disabled={true}
                className={`cursor-none-allowed text-white h-50 rounded-radius10  grid place-items-center focus:outline-none w-full text-center primary normal`}>
                Enroll for Elite
              </button> */}
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
